import { render, staticRenderFns } from "./ValidateExpenseDetail.vue?vue&type=template&id=524b5ca0&scoped=true&"
import script from "./ValidateExpenseDetail.vue?vue&type=script&lang=js&"
export * from "./ValidateExpenseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ValidateExpenseDetail.vue?vue&type=style&index=0&id=524b5ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b5ca0",
  null
  
)

export default component.exports